<template>
  <div class="unitManagement-container">
    <el-aside class="container-left">
      <el-row class="title" :gutter="20">
        <el-col :span="16">
          <div class="grid-content bg-purple">单位列表</div>
        </el-col>
      </el-row>
      <div class="tree-list">
        <el-tree
          :data="unitTreeData"
          node-key="id"
          @node-click="unitClick"
          ref="tree"
          default-expand-all
          highlight-current
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node is-show" slot-scope="{ node }">
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </div>
    </el-aside>
    <el-container class="container-right">
      <div class="con-top">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">部门信息</div>
          </el-col>
        </el-row>
        <el-row class="top-button">
          <el-col :span="16">
            <el-form style="margin-bottom: 20px">
              <el-button
                @click="editOrSave"
                type="primary"
                >{{ btnName }}</el-button
              >
              <el-button
                type="primary"
                @click="toTeamManagement"
                style="width: 136px"
                >班组管理</el-button
              >
            </el-form>
          </el-col>
        </el-row>
        <div class="top-table">
          <table border="1" class="infoTable">
            <tr>
              <th class="table-header">单位名称</th>
              <td class="table-con">
                <template>
                  <el-input disabled v-if="isEdit" v-model="deptInfo.name" />
                  <span v-else>{{ deptInfoList.name }}</span>
                </template>
              </td>
              <th class="table-header">负责人</th>
              <td class="table-con">
                <template>
                  <el-input v-if="isEdit" v-model="deptInfo.leaderName" />
                  <span v-else>{{ deptInfoList.leaderName }}</span>
                </template>
              </td>
            </tr>
            <tr>
              <th class="table-header">外业人员（人）</th>
              <td class="table-con">
                <template>
                  <el-input
                    disabled
                    v-if="isEdit"
                    v-model="deptInfo.maintainNum"
                  />
                  <span v-else>{{ deptInfoList.maintainNum }}</span>
                </template>
              </td>
              <th class="table-header">联系电话</th>
              <td class="table-con">
                <template>
                  <el-input v-if="isEdit" v-model="deptInfo.phone" />
                  <span v-else>{{ deptInfoList.phone }}</span>
                </template>
              </td>
            </tr>
            <tr>
              <th class="table-header">办公地址</th>
              <td class="stable-con" colspan="3">
                <template>
                  <el-input v-if="isEdit" v-model="deptInfo.addr" />
                  <span v-else>{{ deptInfoList.addr }}</span>
                </template>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="con-bottom">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">外业人员管理</div>
          </el-col>
        </el-row>
        <div class="list-wrap">
          <el-form
            size="medium"
            :inline="true"
            :model="queryForm"
            ref="queryForm"
            class="input-form-inline"
            @submit.native.prevent
          >
            <div>
              <el-form-item class="r-20" prop="name">
                <el-input
                  v-model.trim="queryForm.name"
                  @keyup.enter.native="query"
                  placeholder="姓名"
                ></el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="query"
                >查询</el-button
              >
              <el-button @click="reset"
                >取消</el-button
              >
            </div>
            <div style="margin-bottom: 20px">
              <el-button
                type="primary"
                @click="addUser"
                >新增</el-button
              >
              <el-button
                size="medium"
                type="danger"
                @click="delUser"
                >删除</el-button
              >
            </div>
          </el-form>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            size="mini"
            stripe
            height="418"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="24"
              align="center"
              style="padding: 0"
            ></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="55"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="100"
            ></el-table-column>
            <el-table-column prop="sex" label="性别" min-width="50">
              <template slot-scope="scope">
                <span>{{ scope.row.sex == 1 ? "男" : "女" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              label="联系电话"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="maintainCompany"
              label="单位名称"
              min-width="160"
            ></el-table-column>
            <el-table-column
              prop="deptName"
              label="使用部门"
              min-width="160"
            ></el-table-column>
            <el-table-column
              prop="groupName"
              label="作业班组"
              min-width="120"
            ></el-table-column>
            <el-table-column prop="plateNum" label="车辆绑定" min-width="120">
              <template slot-scope="scope">
                <span class="btn-text" @click="toVehicleInfo(scope.row)">{{
                  $judgeEmpty(scope.row.plateNum)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="160">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click.stop="queryDriver(scope.row)"
                  >驾驶证</el-button
                >
                <span class="line">|</span>
                <el-button
                  size="mini"
                  type="text"
                  @click.stop="editUser(scope.row)"
                  >修改</el-button
                >
                <span class="line">|</span>
                <el-button
                  size="mini"
                  type="text"
                  @click.stop="getUserInfo(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </el-container>
    <!-- 驾驶证弹窗 -->
    <el-dialog
      title="驾驶证预览"
      :visible.sync="driverVisible"
      class="mini-dialog"
    >
      <p class="dialog-title">驾驶证主页</p>
      <div class="imgWrap" style="padding-bottom: 30px">
        <!-- <img :src="mainPageUrl" alt="暂未上传驾驶证主页" /> -->
        <el-image
          style="width: 440px; height: 280px"
          :src="mainPageUrl"
          :preview-src-list="mainPageUrlList"
        >
        </el-image>
      </div>
      <p class="dialog-title">驾驶证副页</p>
      <div class="imgWrap">
        <!-- <img :src="vicePageUrl" alt="暂未上传驾驶证副页" /> -->
        <el-image
          style="width: 440px; height: 280px"
          :src="vicePageUrl"
          :preview-src-list="vicePageUrlList"
        >
        </el-image>
      </div>
    </el-dialog>
    <!--新增运维人员对话框-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="submitVisible"
      class="small-dialog"
    >
      <el-form
        :rules="rules"
        ref="addUser"
        :model="StaffForm"
        inline
        label-width="80px"
      >
        <el-col :span="12">
          <el-form-item prop="name" label="姓名">
            <el-input
              v-model="StaffForm.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item prop="phone" label="联系电话">
            <el-input
              v-model="StaffForm.phone"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item prop="maintainCompany" label="单位名称">
            <el-select
              v-model="StaffForm.maintainCompany"
              placeholder="请选择单位名称"
            >
              <el-option
                v-for="item in majorList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="sex" label="性别">
            <el-select
              v-model="StaffForm.sex"
              clearable
              placeholder="请选择性别"
            >
              <el-option
                v-for="item in sexList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="numberId" label="身份证号">
            <el-input
              v-model="StaffForm.numberId"
              placeholder="请输入身份证号"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item prop="deptName" label="使用部门">
            <el-select
              v-model="StaffForm.deptName"
              disabled
              placeholder="请选择使用部门"
            >
               <el-option
                v-for="item in majorList"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item> -->
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
        <el-button @click="submitVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--详情对话框-->
    <el-dialog
      title="详情"
      :visible.sync="detailInfoVisible"
      class="mini-dialog info-box"
    >
      <div style="padding: 0 60px; margin-bottom: 10px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">姓名</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.name) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">性别</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.sex) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">联系电话</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.phone) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">身份证号</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.numberId) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">单位名称</el-col>
            <el-col :span="18">{{
              $judgeEmpty(staffInfo.maintainCompany)
            }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">使用部门</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.deptName) }}</el-col>
          </el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="detailInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="detailInfoVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "UnitManagement",
  data() {
    return {
      queryForm: {
        name: "",
      },
      unitTreeData: [],
      tableData: [],
      deptId: "",
      currentPage: 1,
      limit: 10,
      total: 0,
      detailInfoVisible: false,
      driverVisible: false,
      submitVisible: false,
      mainPageUrl: "",
      mainPageUrlList: [],
      vicePageUrl: "",
      vicePageUrlList: [],
      dialogTitle: "",
      StaffForm: {
        name: "",
        sex: "",
        numberId: "",
        phone: "",
        deptId: "",
        deptName: "",
      },
      sexList: [
        {
          name: "男",
          value: 1,
        },
        {
          name: "女",
          value: 2,
        },
      ],
      rules: {
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入姓名",
          },
        ],
        sex: [
          {
            required: true,
            trigger: "change",
            message: "请选择性别",
          },
        ],
        numberId: [
          { required: true, trigger: "change", message: "请输入身份证号" },
          {
            pattern: this.$formRules.IDCard,
            trigger: "blur",
            message: this.$formRules.IDCardMsg,
          },
        ],
        phone: [
          { required: true, trigger: "change", message: "请输入联系电话" },
          {
            pattern: this.$formRules.phone,
            trigger: "blur",
            message: this.$formRules.phoneMsg,
          },
        ],
        maintainCompany: [
          {
            required: true,
            trigger: "change",
            message: "请选择单位名称",
          },
        ],
      },
      majorList: [], // 使用部门
      staffInfo: {},
      tableVal: [],
      deptInfoList: [],
      btnName: "编辑",
      isEdit: false,
    };
  },
  created() {
    if (sessionStorage.getItem("devopsDeptId")) {
      this.deptId = sessionStorage.getItem("devopsDeptId");
    }
    this.getUnitList();
  },
  watch: {
    unitTreeData(val) {
      if (val) {
        this.show = true;
        this.$nextTick(() => {
          if (this.deptId == "") {
            document.querySelector(".el-tree-node__content").click();
          } else {
            console.log(this.deptId);
            this.$refs.tree.setCurrentKey(this.deptId);
            this.getDeptInfo(this.deptId);
            this.getUserList();
          }
        });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/VehicleInfo") {
      let path = from.path; //path为定义的变量，不是vue的data定义的变量，当前生命周期data还未初始化
      sessionStorage.setItem("pathUrl", path);
    }
    next();
  },
  methods: {
    // 点击跳转车辆详情
    toVehicleInfo(rowData) {
      console.log(rowData);
      let vin = rowData.vin;
      if (!vin) {
        this.$message.warning("车架号为空，无法查看车辆详情");
      } else {
        this.$router.push({
          name: "VehicleInfo",
          params: {
            vin: vin,
            active: "real",
          },
        });
        this.$store.state.MenuStore.menu_path = "车辆管理 > 车辆管理";
      }
    },
    // 确认新增外业管理人员信息
    saveOrUpdate() {
      let data = [];
      // 表单验证通过即可通过接口新增数据
      this.$refs.addUser.validate(async (valid) => {
        if (valid) {
          // 新增
          if (this.editTag == "0") {
            console.log(this.StaffForm);
            data = await this.$axios.post(
              "/api/unit/management",
              this.StaffForm
            );
          } else {
            data = await this.$axios.patch(
              "/api/unit/management",
              this.StaffForm
            );
          }
          let res = data.data;
          if (res.code == 1) {
            //信息提示
            this.$message.success("操作成功");
            //刷新表格
            this.getUserList();
            this.submitVisible = false;
          } else {
            this.$message.warning(res.msg);
          }
        }
      });
    },
    addUser() {
      console.log("新增");
      this.editTag = "0";
      //清空表单数据
      this.$resetForm(this, "addUser");
      //设置弹框标题
      this.dialogTitle = "新增外业人员";
      //显示提交弹框
      this.submitVisible = true;
      // 获取单位名称列表数据
      this.majorList = this.unitTreeData;
    },
    async delUser() {
      //多选删除
      let ids = this.$getIds(this.tableVal);
      if (!ids) {
        return;
      }
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let { data: res } = await this.$axios.delete("/api/unit/management", {
          data: JSON.stringify(ids),
        });
        if (res.code == 1) {
          this.$message.success("操作成功");
          let totalPage = Math.ceil((this.total - 1) / 10);
          let currentPage =
            this.currentPage > totalPage ? totalPage : this.currentPage;
          this.currentPage = currentPage < 1 ? 1 : currentPage;
          this.getUserList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleSelectionChange(val) {
      console.log(val);
      this.tableVal = val;
    },
    // 修改外业人员信息
    editUser(row) {
      this.editTag = "1";
      //清空表单数据
      this.$resetForm(this, "addUser");
      //设置弹框标题
      this.dialogTitle = "修改外业人员信息";
      //显示提交弹框
      this.submitVisible = true;
      //显示需要编辑的数据
      this.getStaffInfo(row.id);
      // 获取单位名称列表数据
      this.majorList = this.unitTreeData;
    },
    // 获取需要修改外业人员的数据
    async getStaffInfo(id) {
      let obj = {};
      obj.id = id;
      let { data: res } = await this.$axios.get("/api/unit/management/info", {
        params: obj,
      });
      console.log(res);
      if (res.code == 1) {
        this.StaffForm = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 跳转到班组管理
    toTeamManagement() {
      this.$router.push({
        name: "/DevopsGroup",
        params: {
          deptId: this.deptId,
        },
      });
      sessionStorage.setItem("isActive", 1);
    },
    //查询驾驶证
    async queryDriver(row) {
      let id = row.deptId;
      this.driverVisible = true;
      this.mainPageUrl = "";
      this.vicePageUrl = "";
      this.mainPageUrlList = [];
      this.vicePageUrlList = [];
      let { data: res } = await this.$axios.get(
        "/api/unit/management/driver/" + id
      );
      if (res.code == 1) {
        let arr = res.data;
        for (let item in arr) {
          if (arr[item].belongType == 1) {
            if (arr[item].imageType == 2) {
              this.mainPageUrl = arr[item].url;
              this.mainPageUrlList.push(this.mainPageUrl);
            } else if (arr[item].imageType == 3) {
              this.vicePageUrl = arr[item].url;
              this.vicePageUrlList.push(this.vicePageUrl);
            }
          }
        }
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getUnitList() {
      let { data: res } = await this.$axios.get("/api/sys/dept/list");
      console.log(res);
      if (res.code == 1) {
        if (res.data.length == 0) {
          this.authorityData = [];
          this.deptId = "";
        }
        this.unitTreeData = res.data;
      } else {
        this.authorityData = [];
        this.deptId = "";
        this.$message.warning(res.msg);
      }
    },
    unitClick(unitData) {
      console.log(unitData);
      this.deptId = unitData.id;
      sessionStorage.setItem("devopsDeptId", this.deptId);
      this.getDeptInfo(this.deptId);
      this.getUserList();
    },
    async getDeptInfo(id) {
      let { data: res } = await this.$axios.get("/api/maintain/dept/" + id);
      if (res.code == 1) {
        this.deptInfoList = res.data;
      } else {
        this.deptInfoList = [];
        this.$message.warning(res.msg);
      }
    },
    async getUserList() {
      let obj = {};
      obj.name = this.queryForm.name;
      obj.deptId = this.deptId;
      obj.limit = this.limit;
      obj.page = this.currentPage;
      let { data: res } = await this.$axios.get("/api/unit/management/list", {
        params: obj,
      });
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      }
    },
    editOrSave() {
      if (this.isEdit) {
        const patter = new RegExp(
          "^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$"
        );
        if (this.deptInfo.phone) {
          if (!patter.test(this.deptInfo.phone)) {
            this.$message.warning("请输入正确格式的手机号！");
            return;
          }
        }
      }
      this.isEdit = !this.isEdit;
      if (this.editFlag == 2) {
        this.editFlag = 1;
        this.btnName = "编辑";
        this.saveDeptInfo(this.deptId);
      } else {
        this.deptInfo = this.deptInfoList;
        this.editFlag = 2;
        this.btnName = "保存";
      }
    },
    async saveDeptInfo(id) {
      let parm = {
        deptId: id,
        addr: this.deptInfo.addr,
        leaderName: this.deptInfo.leaderName,
        phone: this.deptInfo.phone,
      };
      let { data: res } = await this.$axios.patch(
        "/api/maintain/dept/edit",
        parm
      );
      if (res.code == 1) {
        //信息提示
        this.$message.success("操作成功");
        //刷新部门信息
        this.getDeptInfo(id);
      } else {
        this.$message.warning(res.msg);
      }
    },
    query() {
      this.getUserList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getUserList();
    },
    //列表详情弹窗内容
    async getUserInfo(row) {
      let obj = {};
      obj.id = row.id;
      //显示弹框
      this.detailInfoVisible = true;
      let { data: res } = await this.$axios.get("/api/unit/management/info", {
        params: obj,
      });
      if (res.code == 1) {
        this.staffInfo = [];
        this.staffInfo = res.data;
        this.staffInfo.sex = this.staffInfo.sex == 1 ? "男" : "女";
      } else {
        this.$message.warning(res.msg);
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getUserList();
    },
  },
};
</script>

<style lang='scss' scoped>
.unitManagement-container {
  height: calc(100% - 40px);
  margin: 20px;
  overflow: auto;
  background: #fff;
  display: flex;
  .container-left {
    border-right: 1px solid #ccc;
  }
  .container-right {
    flex-direction: column;
    .title {
      margin-left: 0 !important;
      padding-left: 0 !important;
    }
    .con-top {
      height: 240px;
      background: #fff;

      .top-button {
        padding-top: 10px;
      }
      .top-table {
        height: 100%;
        table,
        table tr th,
        table tr td {
          border: 1px solid #dfdfdf;
        }
        .infoTable {
          border-collapse: collapse;
          line-height: 32px;
          font-size: 14px;
          color: #333;
          .table-header {
            width: 120px;
            height: 32px;
            text-align: center;
            background-color: #ddeffd;
          }
          .table-con {
            width: 240px;
            height: 32px;
            text-align: left;
            background: #fff;
          }
          & span {
            padding-left: 12px;
          }
        }
      }
    }
    .con-bottom {
      background: #fff;
      .list-wrap {
        padding-right: 10px;
        .line {
          padding: 0 10px;
          color: #f5f5f5;
        }
      }
    }
  }
  ::v-deep .el-aside {
    margin-right: 10px !important;
  }
  ::v-deep .el-container {
    background: #fff !important;
  }
  ::v-deep .el-form-item__label {
    text-align: left !important;
  }
  ::v-deep .el-form-item__content {
    width: 200px;
  }
  .btn-text {
    cursor: pointer;
    color: #0094ff;
    // text-decoration-line: underline;
  }

  .infoTable /deep/ .el-input__inner {
    height: 32px;
    padding-left: 12px;
  }
  .list-wrap {
    padding: 10px 20px 0 20px;
  }
  .list-wrap /deep/ .input-form-inline {
    padding-top: 0;
  }
  // 模态框样式设置
  .info-box /deep/ .el-dialog {
    width: 60%;
    min-height: 260px;
  }
  .info-box /deep/ .el-dialog__body {
    color: #333;
    height: auto;
  }
  .dialog-title {
    width: 100%;
    height: 20px;
    padding-left: 10px;
    margin-bottom: 10px;
    border-left: 3px solid #0093ff;
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
  ::v-deep .el-dialog__body {
    min-height: 180px;
  }
  .dialog-label {
    font-weight: bold;
  }
  .info-box /deep/ .el-row {
    height: 34px;
    line-height: 34px;
  }
}
</style>